import React from 'react';
import Button from '../../common/Button';
import { faBan } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import revokeSession from './RevokeSessionModal';
import { RemoteSession } from '@mss/mss-component-library';
type RevokeSessionButton = {
  session: RemoteSession;
  fetchSession: () => void;
};

export default function RevokeSessionButton({
  session,
  fetchSession,
}: RevokeSessionButton) {
  const [t] = useTranslation(['remoteAccess', 'common']);

  return (
    <Button
      onClick={() => revokeSession(t, session, fetchSession)}
      data-ta="RevokeSessionButton"
    >
      <FontAwesomeIcon icon={faBan} className="mr-1" />
      {t('REVOKE SESSION')}
    </Button>
  );
}
